export default {
    screenMode: 'FULLSCREEN', //'FULLSCREEN',//POPUP
    /*
    * Flag show that all meta data is loaded before go to any screen*/
    loaded: false,
}
